import React from 'react'
import Box from "@mui/material/Box";
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';


const SearchBoxComponent = ({handleChangeTextValue,label,value}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end'}}>
        <SearchIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
        <TextField id="input-with-sx" value={value} label={label} variant="standard" onChange={handleChangeTextValue} />
    </Box>
  )
}

export default SearchBoxComponent